module.exports = __webpack_public_path__ + "static/media/view-demo-4.f313aa10.png";